/*! License details at fancyapps.com/license */
var o = {
  IMAGE_ERROR: "This image couldn't be loaded. <br /> Please try again later.",
  MOVE_UP: "Move up",
  MOVE_DOWN: "Move down",
  MOVE_LEFT: "Move left",
  MOVE_RIGHT: "Move right",
  ZOOM_IN: "Zoom in",
  ZOOM_OUT: "Zoom out",
  TOGGLE_FULL: "Toggle zoom level",
  TOGGLE_1TO1: "Toggle zoom level",
  ITERATE_ZOOM: "Toggle zoom level",
  ROTATE_CCW: "Rotate counterclockwise",
  ROTATE_CW: "Rotate clockwise",
  FLIP_X: "Flip horizontally",
  FLIP_Y: "Flip vertically",
  RESET: "Reset"
};
export { o as en_EN };